module.exports = __webpack_public_path__ + "img/forget.1ecf1889.png";